"use client";

import { usePathname, useRouter, useSearchParams } from "next/navigation";
import Grid from "@mui/material/Grid2";
import Container from "@mui/material/Container";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";

import { useEffect, useState, useTransition } from "react";

import { FlexBetween, FlexBox } from "@/components/flex-box";
import ProductsGridView from "components/products-view/products-grid-view";

import { Avatar, Box, Skeleton } from "@mui/material";
import { StyledCard } from "../available-shops/styles";
import Link from "next/link";
import Image from "next/image";

export default function ProductSearchPageView({
  filters,
  products,
  pageCount,
  lastIndex,
  firstIndex,
  totalProducts,
}) {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const query = searchParams.get("q");
  const category = searchParams.get("category") || "products";
  const page = searchParams.get("page") || "1";

  const [isPending, startTransition] = useTransition();

  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  if (!mounted) return null;

  const handleChangeSearchParams = (key, value) => {
    if (!key || !value) return;
    const params = new URLSearchParams(searchParams);
    params.set(key, value);
    startTransition(() => {
      router.push(`${pathname}?${params.toString()}`);
    });
  };

  return (
    <Box
      className="bg-white pt-2 pb-4"
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Container sx={{ flexGrow: 1, mb: 3 }}>
        <FlexBetween flexWrap="wrap" gap={2} mb={2}>
          {query ? (
            <div>
              <Typography variant="h5" sx={{ mb: 0.5 }}>
                Buscando “{query}”
              </Typography>
              <Typography variant="body1" sx={{ color: "grey.600" }}>
                {products.length} resultados encontrados
              </Typography>
            </div>
          ) : (
            <div />
          )}

          <FlexBox alignItems="center" columnGap={4} flexWrap="wrap" />
        </FlexBetween>

        <Grid container spacing={4}>
          <Grid
            size={{ xl: 2, md: 3 }}
            sx={{ display: { md: "block", xs: "none" } }}
          />

          <Grid size={{ xl: 10, md: 9, xs: 12 }}>
            {isPending ? (
              <Grid container spacing={1} justifyContent="center">
                {[...Array(8)].map((_, index) => (
                  <Box
                    key={index}
                    sx={{ width: 250, marginRight: 0.5, my: 3 }}
                  >
                    <Skeleton
                      style={{ borderRadius: 10 }}
                      variant="rectangular"
                      width="100%"
                      height={300}
                    />
                  </Box>
                ))}
              </Grid>
            ) : category !== "seller" ? (
              products.length > 0 ? (
                <ProductsGridView products={products} />
              ) : (
                <Box sx={{ textAlign: "center", mt: 5 }}>
                  <Typography variant="h6" color="text.secondary">
                    No se encontraron productos
                  </Typography>
                </Box>
              )
            ) : products.length > 0 ? (
              <Grid container spacing={3}>
                {products.map(({ id, logo, name }) => (
                  <Grid key={id + name} ize={{
                    xl: 8,
                    md: 7,
                    sm: 6,
                    xs: 12
                  }} item>
                    <Link prefetch={false} href={`/shops/${id}`}>
                      <StyledCard>
                        <Avatar
                          className="shop-avatar"
                          variant="rounded"
                          sx={{
                            position: "relative",
                            width: 100,
                            height: 100,
                          }}
                        >
                          <Image
                            alt={name}
                            src={logo}
                            fill
                            sizes="100px"
                            style={{ objectFit: "contain" }}
                          />
                        </Avatar>
                        <center>
                          <p
                            className="mt-1"
                            style={{ width: "190px", fontSize: "0.9rem" }}
                          >
                            {name}
                          </p>
                        </center>
                      </StyledCard>
                    </Link>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Box sx={{ textAlign: "center", mt: 5 }}>
                <Typography variant="h6" color="text.secondary">
                  No se encontraron vendedores
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>
      </Container>

      {products.length > 0 && (
        <Box
          sx={{
            borderTop: "1px solid #eee",
            backgroundColor: "#fff",
            py: 2,
            px: 3,
            mt: "auto",
          }}
        >
          <Container>
            <FlexBetween flexWrap="wrap">
              <Typography variant="body1" sx={{ color: "grey.600" }}>
                Mostrando {firstIndex}-{lastIndex} de {totalProducts}
              </Typography>

              <Pagination
                color="primary"
                variant="outlined"
                page={+page}
                count={pageCount}
                onChange={(_, page) =>
                  handleChangeSearchParams("page", page.toString())
                }
              />
            </FlexBetween>
          </Container>
        </Box>
      )}
    </Box>
  );
}
